export const GET_DOGS = 'GET_DOGS'
export const GET_ID_DOGS = 'GET_ID_DOGS'
export const GET_TEMPERAMENT = 'GET_TEMPERAMENT'
export const GET_NAME_DOGS = 'GET_NAME_DOGS'
export const SEND_DOGS = 'SEND_DOGS'
export const FILTER_ZA= 'FILTER_ZA'
export const FILTER_AZ= 'FILTER_AZ'
export const ORDER_HEIGHT_MAX = 'ORDER_HEIGHT_MAX'
export const ORDER_HEIGHT_MIN = 'ORDER_HEIGHT_MIN'
export const ORDER_WEIGHT_MAX = 'ORDER_WEIGHT_MAX'
export const ORDER_WEIGHT_MIN = 'ORDER_WEIGHT_MIN'
export const FILTER_TEMP = 'FILTER_TEMP'
export const PAGE = 'PAGE'